import queryString from 'query-string';

import { apiUrl, cancellableRequest } from 'src/services/api.js';
import { createObjectMapper } from 'src/utils/object.js';

const paramsMap = {
  query: 'q',
  order: 'sort',
  period: 'y',
  companySize: 'sz',
};

const mapLocationParams = createObjectMapper({
  filterEmpty: true,
  defaults: {
    order: 'relevance',
  },
  map: paramsMap,
});

const mapRequestParams = createObjectMapper({
  filterEmpty: true,
  map: paramsMap,
});

export const RatingsService = {
  getList(params) {
    return cancellableRequest({
      method: 'get',
      url: `${apiUrl}/companies/ratings`,
      params: mapRequestParams(params),
    });
  },
  getMappedParams(params) {
    return mapLocationParams(params);
  },
  syncLocation(params) {
    const mappedParams = mapLocationParams(params);
    const urlQuery = queryString.stringify(mappedParams, { arrayFormat: 'bracket' });
    window.history.replaceState(params, window.location.title, `${window.location.pathname}?${urlQuery}`);
  },
};
